// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import SmartFormLink from '../../../shared/components/smart-form-link/smart-form-link';
import {buildClaimRoutes} from '../../../shared/services/build-claim-route';
import {formatClaimNumber} from '../../../shared/services/format-claim-number';

const PrivateClaimNumberCellRenderer = props =>
    <div className='claim-cell-renderer'>
        {props.data.isSubmittingDealer ?
            <SmartFormLink
                displayText={formatClaimNumber(props.value)}
                formName='CLAIM'
                objectId={props.value}
            /> :
                <a
                    className='claim-link'
                    href={`#${buildClaimRoutes(props.data.claimType, props.data.subClaimType, props.value)}`}
                    rel='noopener noreferrer'
                    target='_blank'
                >
                    {formatClaimNumber(props.value)}
                </a>
        }
    </div>;

PrivateClaimNumberCellRenderer.displayName = 'PrivateClaimNumberCellRenderer';
PrivateClaimNumberCellRenderer.propTypes = {
    data: PropTypes.object.isRequired,
    value: PropTypes.string.isRequired
};

export default PrivateClaimNumberCellRenderer;



// WEBPACK FOOTER //
// ./src/reports/shared/report-cell-renderers/private-claim-number-cell-renderer.js